// Generated by scripts/generate-version.js. Do not edit by hand.
export const APP_RELEASE = "1.6.C";
export const APP_BUILD_ID = "2510261432";
export const APP_VERSION = "1.6.C · 2510261432";
